/**
 * @author aldo-maciel
 */
import {datetime, Schema} from 'simpli-web-sdk'
import ReportsIRouteIndicatorResponse from '@/model/response/ReportsIRouteIndicatorResponse'
import * as Helpers from '@/helpers'
import Endereco from '@/model/resource/Endereco'

export default (model: ReportsIRouteIndicatorResponse): Schema => ({
  nroNotaFiscal: {
    content: model.nroNotaFiscal,
  },
  nomeTransportador: {
    content: ((model.transportador || {responsavel: {razaoSocial: null}}).responsavel).razaoSocial,
  },
  enderecoEntrega: {
    content:
      model.destinatario && Endereco.stringified(model.destinatario.endereco),
  },
  dataCriacao: {
    content: datetime(model.dataCriacao),
    textContent: Helpers.datetimeForCsv(model.dataCriacao),
  },
  dataBaixa: {
    content: datetime(model.dataBaixaSistema),
    textContent: Helpers.datetimeForCsv(model.dataBaixaSistema),
  },
  dataEntrega: {
    content: datetime(model.dataFinalizacao),
    textContent: Helpers.datetimeForCsv(model.dataFinalizacao),
  },
  tempoEntrega: {
    content: model.deliveryTime,
  },
  prevEntrega: {
    content: datetime(model.dataPrevisao),
    textContent: Helpers.datetimeForCsv(model.dataPrevisao),
  },
})
